/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';

import { useSelector } from 'react-redux';

import { ContainerFull, Container, ContainerAlign } from './styles';

import { Breadcumbs } from '~/components/Breadcumbs';
import { BackButton } from '~/components/BackButton';

const DashboardCompletude = () => {
  const { systemConfig } = useSelector(state => state.auth);

  const cpfUser = sessionStorage.getItem('cpf');

  const { urlSuperset } = systemConfig;

  const urlIframe = `${urlSuperset}/login/?username=${cpfUser}&redirect=/superset/dashboard/completude/`;

  return (
    <>
      <ContainerFull>
        <div className="ContainerBreadcumbs">
          <Breadcumbs
            path="completude"
            pathTitle="Dashboard de Completude de Dados"
          />
          <ContainerAlign>
            <BackButton />
          </ContainerAlign>
        </div>

        <Container>
          <iframe
            id="frame"
            name="frame"
            title="SuperSet"
            src={urlIframe}
            frameBorder="0"
          />
        </Container>
      </ContainerFull>
    </>
  );
};

export default DashboardCompletude;
